import React, { useMemo } from "react";
import styles from "./index.module.scss";
import { format, fromUnixTime } from "date-fns";
import { formatDate } from "@/utils/format-date.util";

type Props = {
  timestamp: number | string | undefined;
};

const TransactionTimestamp = ({ timestamp }: Props) => {
  const time = useMemo(() => {
    if (!Number(timestamp) || isNaN(Number(timestamp))) return "";
    return formatDate(fromUnixTime(Number(timestamp)), "dateAt");
  }, [timestamp]);

  return <div className={styles.time}>{time}</div>;
};

export default TransactionTimestamp;
